module.exports = __webpack_public_path__ + "img/p17_03.f1aabd6c.png";